module.exports = __webpack_public_path__ + "img/symbol_11.aa7d797d.png";